import { Col, Container, Form, Row } from "react-bootstrap";

const categoryOrder: Record<string, Array<string>> = {
  category: [
    "rowComponents",
    "rowContent",
    "blockComponents",
    "blockContent",
    "baseTemplates",
    "design",
    "automations",
  ],
};

const sortOptions = (level: string, options: Array<string>) => {
  const orderIndex = Object.fromEntries((categoryOrder[level] || []).map((v, i) => [v, i]));

  const sortedValues = [...options].sort((a, b) => {
    const aIndex = orderIndex[a];
    const bIndex = orderIndex[b];

    // both are in order list
    if (aIndex !== undefined && bIndex !== undefined) return aIndex - bIndex;

    // only a is in order list
    if (aIndex !== undefined) return -1;

    // only b is in order list
    if (bIndex !== undefined) return 1;

    // neither are in order list — sort alphabetically
    return a.localeCompare(b);
  });

  return sortedValues;
};

function SelectionWithPath({
  availableOptions,
  levels,
  currentSelectionPerLevel,
  dropdownChange,
}: {
  availableOptions: Record<string, string[]>;
  levels: string[];
  currentSelectionPerLevel: Record<string, string>;
  dropdownChange: (level: string, value: string) => void;
}) {
  return (
    <Container>
      {availableOptions[Object.keys(availableOptions)[0]].length > 0 && (
        <Row>
          {levels.map((level) => {
            return (
              <Form.Group as={Col} key={level} className="m-0 p-0 pe-1">
                <Form.Select
                  value={currentSelectionPerLevel[level]}
                  key={level}
                  onChange={(e) => dropdownChange(level, e.target.value)}
                  style={{ backgroundColor: "#e4e6f5", padding: "10px", height: "75px" }}
                >
                  {sortOptions(level, availableOptions[level]).map((value: string) => {
                    return (
                      <option key={value} value={value}>
                        {value}
                      </option>
                    );
                  })}
                </Form.Select>
                <div style={{ fontSize: "12px", color: "#9b9fc2", float: "right" }}>
                  {availableOptions[level].length} {level}s to choose from
                </div>
              </Form.Group>
            );
          })}
        </Row>
      )}
    </Container>
  );
}

export default SelectionWithPath;
